import createPersistedState from 'use-persisted-state';

// Which data the locally-running backend should hit. Only meaningful in local dev — a production
// build never sends the override and the deployed backend ignores it. Defaults to the safe
// 'local' (STAGING_ clones).
export type DataEnv = 'local' | 'production';

const KEY = 'sbly-tools:data-env';

// The toggle exists only on a stack its person started with SBLY_PROD_DATA_TOGGLE=1 (the dev stack
// passes it here as REACT_APP_PROD_DATA_TOGGLE); the local backend refuses production without it.
export const PROD_DATA_TOGGLE = process.env.REACT_APP_PROD_DATA_TOGGLE === '1';
const useDataEnvState = createPersistedState(KEY);

/** Reactive read/write of the local "Production data" toggle (syncs across tabs). */
export default function useDataEnv(): [DataEnv, (value: DataEnv) => void] {
  const [env, setEnv] = useDataEnvState<DataEnv>('local');
  return [env, setEnv];
}

/** Non-hook accessor for the service layer (same key use-persisted-state writes). */
export function getDataEnv(): DataEnv {
  if (!PROD_DATA_TOGGLE) return 'local'; // a choice left in localStorage from a run with it on
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '"local"') === 'production' ? 'production' : 'local';
  } catch {
    return 'local';
  }
}
